import React from 'react';
import { Reveal } from 'semantic-ui-react';
import 'semantic-ui-less/definitions/elements/reveal.less';

export default Reveal;
